import { useMe } from "@/api/user"
import { useState } from "react"

export const useSupport = () => {
  const me = useMe()

  const [toggle, setToggle] = useState(false)

  return {
    openChat: () => {
      window.$unthread.inAppChat("start", {
        user: {
          name: me.data?.name,
          email: me.data?.email,
          verificationHash: me.data?.supportHash,
        },
      })
      window.$unthread.inAppChat("toggle", toggle ? "hide" : "show")
      setToggle(!toggle)
    },
    clearChat: () => {
      window.$unthread.inAppChat("stop")
    },
  }
}
